import ContactSection from './ContactSection';
import ExperienceSection from './ExperienceSection';
import Footer from './Footer';
import IntroSection from './IntroSection';
import OfferSection from './OfferSection';
import ProjectsSection from './ProjectsSection';
import Seo from './Seo';
import TechnologiesSection from './TechnologiesSection';

type Props = {};

export default function MainPage({}: Props) {
	return (
		<>
			<Seo title="Olaf Dalach - PH4SM4 SOLUTIONS" path="/" />
			<main>
				<IntroSection />
				<OfferSection />
				<ProjectsSection />
				<ExperienceSection />
				<TechnologiesSection />
				<ContactSection />
			</main>

			<Footer color="#101010B6" />
		</>
	);
}
